import * as React from "react";
import classnames from "classnames";
/* empty css                     */
function OptionCardGroup(props) {
  const { items, onSelect, bodyRenderer, className, selected, groupName } = props;
  const rootClassNames = classnames("option-card-group", className);
  const itemClassNames = classnames("option-card-group__item", {
    [`${className}__item`]: className
  });
  const radioClassNames = classnames("option-card-group__radio", {
    [`${className}__radio`]: className
  });
  const inputClassNames = classnames("option-card-group__input", {
    [`${className}__input`]: className
  });
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("ul", { className: rootClassNames, "data-t": props["data-t"], role: "radiogroup" }, items.map((item) => {
    const isSelected = selected && item.id === selected.id;
    return /* @__PURE__ */ React.createElement("li", { className: itemClassNames, key: item.id }, /* @__PURE__ */ React.createElement(
      "label",
      {
        className: classnames(radioClassNames, {
          "option-card-group__radio--disabled": item.disabled,
          "option-card-group__radio--checked": isSelected
        })
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: inputClassNames,
          name: groupName,
          type: "radio",
          value: item.id,
          checked: isSelected,
          disabled: item.disabled,
          onChange: () => onSelect(item),
          "data-t": item.id
        }
      ),
      bodyRenderer(item)
    ));
  }));
}
export {
  OptionCardGroup as default
};
//# sourceMappingURL=OptionCardGroup.js.map
